/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AthleteDTO } from './athleteDTO';


export interface ActionDTO {
    addedByClient?: boolean;
    annotatedVideo?: string;
    athlete?: AthleteDTO;
    defaultReportTemplate?: string;
    files?: Array<string>;
    folderPath?: string;
    free?: boolean;
    id?: string;
    name?: string;
    poseData?: string;
    primaryImage?: string;
    sampleFile?: string;
}

